'use client'

import { httpClient } from '@/core/services/http'
import { UnauthorizedError } from '@/core/types/errors/http-error'
import { refreshTokenAction } from '@/features/auth/actions/refresh-token.action'
import { useEffect, useTransition } from 'react'

export function RefreshTokenProvider() {
  const [, startTransition] = useTransition()

  useEffect(() => {
    const id = httpClient.addResponseInterceptor(
      req => req,
      err => {
        if (err instanceof UnauthorizedError) {
          startTransition(async () => {
            await refreshTokenAction()
          })
        } else {
          throw err
        }
      },
    )

    return () => httpClient.ejectInterceptor(id)
  }, [])

  return null
}
